import {
  Terminal,
  MessageSquare,
  Cpu,
  GitBranch,
  Shield,
  FileText,
  Box,
  Cloud,
} from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const cards = [
  {
    title: 'Terminal',
    desc: 'Local shell or SSH to any server',
    icon: Terminal,
    path: '/terminal',
    color: '#58a6ff',
  },
  {
    title: 'AI Chat',
    desc: 'Code generation, review, and Q&A',
    icon: MessageSquare,
    path: '/chat',
    color: '#3fb950',
  },
  {
    title: 'Providers',
    desc: 'Ollama, MLX, vLLM, OpenAI, more',
    icon: Cpu,
    path: '#',
    color: '#d29922',
  },
  {
    title: 'Projects',
    desc: 'Analyze and manage repositories',
    icon: GitBranch,
    path: '#',
    color: '#bc8cff',
  },
  {
    title: 'Security',
    desc: 'Audit code, scan dependencies',
    icon: Shield,
    path: '#',
    color: '#f85149',
  },
  {
    title: 'Documentation',
    desc: 'Index and search project docs',
    icon: FileText,
    path: '#',
    color: '#79c0ff',
  },
  {
    title: 'Templates',
    desc: 'Scaffold projects instantly',
    icon: Box,
    path: '#',
    color: '#56d364',
  },
  {
    title: 'Aether Host',
    desc: 'Model registry & deployment',
    icon: Cloud,
    path: '#',
    color: '#d2a8ff',
  },
];

export function DashboardPage() {
  const navigate = useNavigate();

  return (
    <div style={{ padding: 32, maxWidth: 1000, margin: '0 auto' }}>
      <div style={{ marginBottom: 32 }}>
        <h1 style={{ fontSize: 24, fontWeight: 700, color: '#d6a94e', marginBottom: 4 }}>
          Orion Web
        </h1>
        <p style={{ fontSize: 14, color: '#8b949e' }}>
          AI-powered development assistant — terminal, chat, agents, and more
        </p>
      </div>
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))',
          gap: 12,
        }}
      >
        {cards.map(({ title, desc, icon: Icon, path, color }) => (
          <button
            key={title}
            onClick={() => path !== '#' && navigate(path)}
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: 8,
              padding: 20,
              borderRadius: 8,
              border: '1px solid #30363d',
              background: '#161b22',
              cursor: path !== '#' ? 'pointer' : 'default',
              textAlign: 'left',
              transition: 'border-color 0.15s',
            }}
            onMouseEnter={(e) => (e.currentTarget.style.borderColor = color)}
            onMouseLeave={(e) => (e.currentTarget.style.borderColor = '#30363d')}
          >
            <Icon size={24} color={color} />
            <div style={{ fontSize: 14, fontWeight: 600, color: '#c9d1d9' }}>{title}</div>
            <div style={{ fontSize: 12, color: '#8b949e', lineHeight: 1.4 }}>{desc}</div>
          </button>
        ))}
      </div>
    </div>
  );
}
